import { gql } from "@apollo/client"

export const GET_ORGANIZATION_RECEIPTS = gql`
  query getOrganizationReceipts {
    myOrganization {
      id
      receipts {
        id
        chargeObjectId
        date
        total
        order {
          id
          paymentIntentId
          number
          createdAt
          customerEmail
          shippingMethodName
          shippingPrice
          currency
          total
          orderType
          isPaid
          lines {
            productName
            quantity
            totalPrice
            unitPrice
            id
          }
        }
        receiptUrl
        bookmarked
        buyerName
      }
    }
  }
`
